'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerContractComponent = exports.sellerContractComponent = {
    template: require('./contract.html'),
    bindings: {
        contract: '<',
        seller: '<'
    },
    controllerAs: 'vm',
    controller: ["$state", "common", "Analytics", function controller($state, common, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            if (!vm.seller) {
                $state.go('error');
            }

            common.setTitle(vm.contract.title);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/contract/' + vm.contract.id, vm.contract.title);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/contract.js
// module id = 1017
// module chunks = 0